import { useState } from "react"
import { GalleryVerticalEnd } from "lucide-react"
import { useMsal } from "@azure/msal-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
} from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import { loginRequest } from "@/auth/msalConfig"
import { useAppSelector } from "@/store"

export function LoginForm({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const { instance } = useMsal()
  const [email, setEmail] = useState("")
  const org = useAppSelector((state) => state.organization)

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault()
    instance.loginRedirect({
      ...loginRequest,
      loginHint: email,
    })
  }

  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <form onSubmit={handleLogin}>
        <FieldGroup>
          <div className="flex flex-col items-center gap-2 text-center">
            <a
              href="#"
              className="flex flex-col items-center gap-2 font-medium"
            >
              <div className="flex size-8 items-center justify-center rounded-md">
                <GalleryVerticalEnd className="size-6" />
              </div>
              <span className="sr-only">{org.name}</span>
            </a>
            <h1 className="text-xl font-bold">Welcome to {org.name}</h1>
            <FieldDescription>
              Enter your email to sign in with your organization account.
            </FieldDescription>
          </div>
          <Field>
            <FieldLabel htmlFor="email">Email</FieldLabel>
            <Input
              id="email"
              type="email"
              placeholder="m@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Field>
          <Field>
            <Button type="submit" className="w-full">
              Continue with Microsoft
            </Button>
          </Field>
        </FieldGroup>
      </form>
    </div>
  )
}
